import React, {Component} from 'react';

import './techInfo.scss';

class TechInfo extends Component{

    render() {
        let version = process.env.REACT_APP_VERSION,
            lastBuild = process.env.REACT_APP_BUILD_TIME;

        return (
            <div className="tech-info">
                <span>version: v.{version}</span>
                <span>last build: {lastBuild}</span>
            </div>
        );
    }
}
export default TechInfo;
